export default [ {
  path: '/xiqueClinc',
  name: 'xiqueClinc',
  redirect: {
    name: 'xiqueClincBaseInfo'
  },
  meta: {
    title: '喜鹊医生',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/xiqueClinc/index'], resolve)
  },
  children: [{
    path: 'baseinfo',
    name: 'xiqueClincBaseInfo',
    meta: {
      title: '喜鹊医生',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/xiqueClinc/baseInfo'], resolve)
    }
  }, {
    path: 'zhuanjia/:id',
    name: 'xiqueClincZhuanjia',
    meta: {
      title: '专家问诊',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/xiqueClinc/general'], resolve)
    }
  }, {
    path: 'general',
    name: 'xiqueClincGeneral',
    meta: {
      title: '全科门诊',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/xiqueClinc/general'], resolve)
    }
  }, {
    path: 'report',
    name: 'xiqueClincReport',
    meta: {
      title: '体检报告解读',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/xiqueClinc/general'], resolve)
    }
  }, {
    path: 'consult',
    name: 'xiqueClincConsult',
    meta: {
      title: '我的咨询',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/xiqueClinc/consult'], resolve)
    }
  }, {
    path: 'questionnaire',
    name: 'xiqueClincQuestionnaire',
    meta: {
      title: '健康状况自我诊断表',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/xiqueClinc/questionnaire'], resolve)
    }
  }]
} ]
